/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Manual/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Manual({
  children,
  viewPath = "/DesignSystem/EditAutomation/TriggerType/AppointmentBookingsStateUpdate/Content/AutomationType/Manual"
  
}) {
let constantData = 'pre'
let automationTriggerTypeValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'trigger_type',
})
let aggregateData = fromAggregate.equals(constantData, automationTriggerTypeValueData)
let onClick = fromHelpers.useOnSelectPreTriggerType({
  children,
  viewPath
  
})
let constantData1 = 'post'
let automationTriggerTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'trigger_type',
})
let aggregateData1 = fromAggregate.equals(constantData1, automationTriggerTypeValueData1)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick1 = fromHelpers.useOnSelectPostTriggerType({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Manual.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Radial
  viewPath={`${viewPath}/Radial`}
 paddingTop={0}
 paddingBottom={0}
 text="Before"
 onClick={onClick}
 data="'pre'"
 data="automation.trigger_type"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
/>
<Radial
  viewPath={`${viewPath}/Radial`}
 paddingBottom={0}
 paddingTop={0}
 text="After"
 marginRight={dtSpaceXs}
 onClick={onClick1}
 data="'post'"
 data="automation.trigger_type"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData1}
/>
</div>
{children}
</React.Fragment>)
}